import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 5EADCD37-E186-4701-B55D-490373E248DE
 * name clock-time-five
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clock-time-five.svg
 * tags
 * - Date / Time 
 */
export const ClockTimeFiveIcon = createSvgIcon(<><path d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12S17.5 2 12 2M14 17L11 11.8V7H12.5V11.4L15.3 16.3L14 17Z" /></>, 'ClockTimeFiveIcon');
export default ClockTimeFiveIcon